<div
  class="review-metadata-overview w-100 d-flex p-3"
  *ngIf="changeRequest"
  [class.flex-column]="showDiff && activeChangeRequest">
  <div class="w-100 mb-3" *ngIf="showDiff && activeChangeRequest">
    <irembogov-field-diff-viewer
      sectionTitle="Metadata Changes"
      [oldData]="$any(activeChangeRequest)"
      [newData]="$any(changeRequest)"
      [fieldLabels]="{
        serviceName: 'Service Name',
        serviceSummary: 'Service Summary',
        categoryId: 'Category',
        applicantType: 'Applicant Type',
        knowledgeBaseUrl: 'Knowledge Base URL',
        serviceType: 'Service Type',
        debugMode: 'Debug Mode',
        initialRfaEnforced: 'Initial RFA Enforced'
      }">
    </irembogov-field-diff-viewer>
  </div>
  <div class="flex-grow-1 mw-70">
    <irembogov-configuration-metadata-overview-form
      [inReviewMode]="true"
      [changeRequest]="changeRequest"
      class="col-md-8">
    </irembogov-configuration-metadata-overview-form>
  </div>
  <irembogov-reviewer-issues-entry-form-widget
    class="justify-self-end w-30"
    [changeRequestId]="changeRequest.id"
    [reviewSection]="EServiceChangeRequestReviewSection.OVERVIEW"
    (goToNext)="
      reviewMetadataCompleted.emit($event)
    "></irembogov-reviewer-issues-entry-form-widget>
</div>
